// File: src/pages/NotificationsPage.jsx
import React, { useEffect, useContext } from "react";
import { NotificationContext } from "../context/NotificationContext";
import { AuthContext } from "../context/AuthContext";

const formatDateTime = (isoString) => {
  const date = new Date(isoString);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const NotificationItem = ({ notif }) => {
  const icons = {
    system: "🌤️",
    chat: "💬",
    booking: "📅",
    default: "🔔",
  };

  return (
    <div
      style={{
        borderBottom: "1px solid #ddd",
        padding: "10px 15px",
        backgroundColor: notif.type === "system" ? "#f0fdf4" : "#fff",
        borderRadius: "6px",
        marginBottom: "10px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      <div style={{ fontSize: "1.1em", fontWeight: "600", marginBottom: 4 }}>
        {icons[notif.type] || icons.default}{" "}
        {notif.type?.toUpperCase() || "NOTIFICATION"}
      </div>
      <div style={{ marginBottom: 6 }}>{notif.message}</div>
      <div style={{ fontSize: "0.8em", color: "#666" }}>
        {notif.timestamp ? formatDateTime(notif.timestamp) : "Unknown time"}
      </div>
    </div>
  );
};

const NotificationsPage = () => {
  const { user } = useContext(AuthContext);
  const { notifications, fetchNotifications } = useContext(NotificationContext);

  useEffect(() => {
    if (user?._id) {
      fetchNotifications(user._id);
    }
  }, [user, fetchNotifications]);

  if (!user) {
    return (
      <div
        style={{
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
          padding: 20,
        }}
      >
        <p>Please login to see notifications.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "40px 15px",
      }}
    >
      <div style={{ maxWidth: 600, margin: "0 auto" }}>
        <h2 style={{ marginBottom: 20 }}>🔔 Your Notifications</h2>
        {notifications.length === 0 ? (
          <p>Loading....</p>
        ) : (
          notifications.map((notif) => (
            <NotificationItem key={notif._id || notif.timestamp} notif={notif} />
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
